module.exports = __webpack_public_path__ + "img/174.quality_of_cooking.73e84dff.svg";